export const MAINTENANCE = 10109998
export const VERSION_ERROR = 10109997
export const USER_BAN = 10100000
export const USER_LOGIN = 10100001
export const ERROR_LOGIN_NOT_FOUND_USER = 10100201
export const ERROR_LOGIN_USER = 10100202
export const GROUP_MEMBER_NOT_FOUND = 10101011
export const GROUP_NOT_FOUND = 10101012
export const GROUP_DISSOLUTION = 10101013
export const GROUP_MEMBER_EXPIRED = 10101014
export const GROUP_EXPIRED = 10101015

const state = {
	statusCode: null,
	message: null,
}

const mutations = {
	setStatusCode(state, status) {
		state.statusCode = status
	},
	setMessage(state, message) {
		state.message = message
	},
}

export default {
	namespaced: true,
	state,
	mutations
}
